module.exports = __webpack_public_path__ + "static/img/csbcLogo.00f47ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/csbcLogo.png
// module id = bD7M
// module chunks = 35